import { Component, OnInit } from '@angular/core';
import { ContactChildTab, ContactTabList } from './contact.const';
import { NavigationEnd, Router } from '@angular/router';
import { getCurrentTab } from './contact.const';

@Component({
  selector: 'settings-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
})
export class ContactComponent implements OnInit {
  public currentTab;
  public readonly contactTabList = ContactTabList;

  constructor(private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentTab = getCurrentTab(event.url);
      }
    });
  }

  ngOnInit() {
    this.currentTab = getCurrentTab(this.router.url);
  }

  onChangeTab(tabId: ContactChildTab) {
    this.currentTab = tabId;
    this.router.navigate([tabId]);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/contact/contact.component.ts